<template>
  <div class="wall-surface-area__table-wrap">
    <!-- header-row -->
    <div class="surface-area__table-header-row">
      <div class="table-headers">Orientation</div>
      <div class="table-headers">WWR orientation-wise (Glass + Frame)%</div>
      <div class="table-headers">
        Opening area <br />
        (sq.M)
      </div>
    </div>
    <!-- data-rows -->
    <div v-for="(orientation, j) in schema.inputs.step3B.wwrWindowArrObj" :key="j" class="data-row-wrap">
      <!-- <div class="data-field data-label">N</div> -->
      <template v-if="schema.inputs.step3A.wallSurfaceAreaArrObj[j].calcWallArea !== 0">
        <div class="data-field">
          <div class="wall-direction">
            <span> {{ orientation.windowOrientation }}</span>
          </div>
        </div>
        <div class="data-field">
          <!-- <lv-input type="number" v-model="orientation.windowOrientationWwr" outlined placeholder="%"> -->
            <v-text-field outlined dense type="number" v-model="orientation.windowOrientationWwr" suffix="%" placeholder="Enter ">
        </v-text-field>
            <!-- <template  #append>%
      </template> -->
          </lv-input>
        </div>
        <div class="data-field">
          <!-- <lv-input type="number" disabled outlined placeholder="0.00" v-model="orientation.calcWindowOpeningArea" /> -->
          {{ orientation.calcWindowOpeningArea }}
        </div>
      </template>
    </div>
    <hr />
    <div class="step3B__wwr-note"><v-alert text dense color="teal" icon="mdi-alert-circle" border="left"> Note: Percentage input in each direction should be less than or equal to 100% </v-alert></div>

    <div class="step-3B__summary">
      <div class="summary-head">Summary:</div>
      <div class="summary-block__wrap">
        <div class="summary-field__row">
          <div class="sumarry-field__label">Total opening area <span class="units">(sq.M):</span></div>

          <div class="summary-field__value">{{ step3B.total_opening_area }} <span class="units"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
export default {
  components: {
    LvInput,
  },
  data() {
    return {
      totalOpenArea: 0,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
    step3A: {
      get: function() {
        return this.$store.state.schema.inputs.step3A;
      },
      set: function(Step3A) {
        this.$store.dispatch('setStep3A', Step3A);
      },
    },
  },

  beforeUpdate() {
    this.calculateWindowOpeningArea();
    this.totalOpeningArea();
  },
  watch: {
    step3B: {
      handler: function() {
        // this.calculateWindowOpeningArea();
        this.totalOpeningArea();
      },
      immediate: true,
    },
    step3A: {
      handler: function() {
        this.calculateWindowOpeningArea();
        this.totalOpeningArea();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    //find activated directions in wwr
    calculateWindowOpeningArea() {
      for (let k = 0; k <= this.step3A.wallSurfaceAreaArrObj.length - 1; k++) {
        // changing lvInput string to number
        this.step3B.wwrWindowArrObj[k].windowOrientationWwr = +this.step3B.wwrWindowArrObj[k].windowOrientationWwr;
        // console.log('window input %', this.step3B.wwrWindowArrObj[k].windowOrientationWwr);
        if (this.step3B.wwrWindowArrObj[k].windowOrientationWwr !== 0) {
          this.step3B.wwrWindowArrObj[k].calcWindowOpeningArea = +(+this.schema.inputs.step3A.wallSurfaceAreaArrObj[k].calcWallArea * +0.01 * +this.step3B.wwrWindowArrObj[k].windowOrientationWwr).toFixed(2);
        }
        else{
        this.step3B.wwrWindowArrObj[k].windowOrientationWwr=0;
this.step3B.wwrWindowArrObj[k].calcWindowOpeningArea=0;
        }
      }
    },
    totalOpeningArea() {
      this.totalOpenArea = 0;
      this.step3B.total_opening_area = 0;
      for (let i = 0; i <= this.step3B.wwrWindowArrObj.length - 1; i++) {
        this.step3B.total_opening_area = +(+this.step3B.total_opening_area + +this.step3B.wwrWindowArrObj[i].calcWindowOpeningArea).toFixed(2);
      }
      // this.step3B.total_opening_area = (+this.totalOpenArea).toFixed(2);
    },
  },
};
</script>

<style lang="scss">
.surface-area__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  margin-top: 12px;
  .table-headers {
    color: #343f4b;
    padding: 12px;
    font-size: 16px;
    width: 33.33%;
    text-align: center;
  }
}
.data-row-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px 12px 4px 12px;
  //   align-items: center;
  .data-field {
    width: 25%;

    .wall-direction {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    // text-align: center;
  }
}
.step3B__wwr-note {
  // background-color: #b3f5db;

  // font-style: italic;
  padding: 4px 2px 4px 2px;
  margin: 12px 0px;
}
.step-3B__summary {
  margin-top: 10px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
</style>
